import { cDisplay } from "../creator/cDisplay";
import { cGame } from "../creator/cGame";
import { cButton } from "../creator/cGameObjects/cButton";
import { cContainer } from "../creator/cGameObjects/cContainer";
import { cInlineDisplay } from "../creator/cGameObjects/cInlineDisplay";
import { cSprite } from "../creator/cGameObjects/cSprite";
import { cTextSprite } from "../creator/cGameObjects/cTextSprite";
import { cScene } from "../creator/cScene";
import { ScreenItem } from "../creator/dataTypes";

export class gamePackmanDisplay extends cDisplay {

  private endMapping = {
    '1_2' :'game_1_tierpflegerin.png',
    '1_5' :'game_1_forstwirtin.png',
    '1_8' :'game_1_zellbiologin.png',
    '1_14':'game_1_biolehrerin.png',
    '1_17':'game_1_tieraerztin.png',

    '2_3' :'game_2_tiscler.png',
    '2_8' :'game_2_abi.png',
    '2_11' :'game_2_abi.png',
    '2_14' :'game_2_abi.png',
    
    '3_2' :'game_3_maschine.png',
    '3_5' :'game_3_maschine.png',
    '3_8' :'game_3_maschine.png',
    '3_11' :'game_3_maschine.png',
    '3_14' :'game_3_maschine.png',
    '3_17' :'game_3_maschine.png',
  }


  private curHead: Phaser.GameObjects.Sprite
  private clouds: Phaser.GameObjects.Container
  private road: Phaser.Tilemaps.TilemapLayer
  private buildings: Phaser.Tilemaps.TilemapLayer
  private xx: number = 2;
  private yy: number = 9;
  public camX:number = -1960;
  private holder: cContainer
  private curGame: any;

  private tilemap: any;

  private booklist:any[]

  init() {
    super.init();

    (this.scene as cScene).ev.addListener("action", (command, options) => {
      switch (options.command) {
        case "startgame":
          var gameToLoad = (this.scene as cScene).getState('game');

          let onCompleted = (e:any)=>{    
            this.createMap(gameToLoad);
          }

          this.scene.load.tilemapTiledJSON('curgame','assets/level_1.json')
          this.scene.load.once('complete',onCompleted)
          this.scene.load.start();
          break;
        case 'go_up':
          this.moveVert(-1);
          break;
        case 'go_right':
          this.moveRight();
          break;
        case 'go_down':
          this.moveVert(1);
          break;
      }
    });
  }

  createMap( game ){
    //game = 1;
    if (game===0) game = 1
    console.log('GAME',game)

    this.curGame = game;

    const map = this.scene.make.tilemap({ 
      key: 'curgame', 
      tileWidth: 50,
      tileHeight: 50      
    });    

    this.booklist = [];

    var tileset = map.addTilesetImage('tileset', 'game_tileset',50, 50);
    this.road = map.createLayer('kind_'+game, tileset,0,0);

    var tilesetBuildings = map.addTilesetImage('buildings', 'buildings_tileset',50, 50);

    var buildings = map.getObjectLayer('buildings');
    buildings.objects.forEach( (ob)=>this.appendItem(ob) );

    var extra = map.getObjectLayer('kind_'+game+'_obj');
    extra.objects.forEach( (ob)=>this.appendItem(ob) );

    this.curHead =  this.scene.add.sprite(50+25,500-25,'head_'+game);
    this.add(this.curHead);

    this.scene.children.bringToTop(this);
    this.bringToTop( this.getByName('controls_holder'))
  
    this.tilemap = map;
  }


  appendItem( ob ){
    var obj;
    var n:cTextSprite
    var n_data:any = {};
    var rot: string = '0';

    //console.log(ob.gid,ob.name, ob.rotation, rot)

    switch (ob.gid){
      case 15:
        n = this.getByName('building_');
        n_data = this.copyObj(n.modules.data.data)
        n_data.text = ob.name
        let [sp,fr] = String(n_data.asset).split(':')
        n_data.asset = sp +':' + String(ob.type).replace('building_','') + '.png'
        break;
      case 14:
        n = this.getByName('book_');
        n_data = this.copyObj(n.modules.data.data)
        n_data.text = ob.name;
        break;
      case 17:
        n = this.getByName('cloud_');
        n_data = this.copyObj(n.modules.data.data)
        n_data.text = ob.name
        break;
      case 16:
        n = this.getByName('sign_');
        n_data = this.copyObj(n.modules.data.data)
        n_data.initProps.angle = String(ob.rotation);
        n_data.text = ob.name;
        break;
      default:
        n_data = null;
        console.log('NOT FOUND',ob)
    }

    if (n_data){
      n_data.initProps.visible = '1'
      obj = new cTextSprite(this.scene as cScene, n_data);        
      obj.x = ob.x
      obj.y = ob.y
      this.add(obj);
      if (ob.gid === 14){
        this.booklist.push(obj)
      }
    }else{
      console.warn('UNABLE TO CREATE ',ob.name)
    }
  }

  copyObj(b:any){
    return JSON.parse( JSON.stringify(b));
  }


  moveRight(){
    var curX:number = this.xx
    var ok: boolean = true
    while (ok){
      var tl = this.road.getTileAt(curX,this.yy);
      if (tl) {
        var isCorssing = [13,9,10].indexOf(tl.index) != -1
        if (isCorssing && curX != this.xx){
          ok = false
        }else{
          curX++ 
        }
      }else{
        ok=false 
        curX -= (this.xx==curX) ? 0 : 1;
      };
    }
    var sp = Math.abs(this.xx-curX)
    this.xx = curX;
    this.moveHead(sp);
  }

  moveVert(dir){
    var curY:number = this.yy
    var ok: boolean = true
    while (ok){
      var tl = this.road.getTileAt(this.xx,curY);
      if (tl) {
        var isCorssing = [7].indexOf(tl.index) != -1
        if (isCorssing && curY != this.yy){
          ok = false
        }else{
          curY+=dir
        }
       }else{
        ok=false        
        curY -= (this.yy==curY) ? 0 : dir
       };
    }
    var sp = Math.abs(this.yy-curY)
    this.yy = curY;
    this.moveHead(sp);
  }

  addPickupAnim(ref){
    var sp = this.scene.add.sprite(ref.x,ref.y-40,'');
    var frameNames = this.scene.anims.generateFrameNames('pickup_animation', {
      start: 1, end: 12, zeroPad: 0,
      prefix: 'pickup_', suffix: '.png'
    });
    this.scene.anims.create({ 
      key: 'explode', 
      frames: frameNames, 
      frameRate: 16, 
      repeat: 0,
      hideOnComplete: true
     });
    sp.anims.play('explode');
    sp.on('animationcomplete', ()=>{
      
    });

    (this.scene as cScene).snd( 'snd_pickup');
  }


  moveHead( sp ){
    
    this.scene.tweens.add({
      targets: this.curHead,
      x: (this.xx * 50)+25,
      y: (this.yy * 50)+25,
      duration: sp * 100,
      onUpdate:()=>{
        this.booklist = this.booklist.filter((el)=>{
          var d = Phaser.Math. Distance.Between(el.x,el.y,this.curHead.x,this.curHead.y);
          if (d < 30){
            this.addPickupAnim(el);
            el.destroy();
            return false
          }else{
            return true
          }
        })        
      },
      onComplete:()=>{        
        if (this.xx === 54){
          var gameToLoad = (this.scene as cScene).getState('game');
          //(this.scene as cScene).triggerSceneEvent("completed_child_" + gameToLoad, { 
          this.curHead.visible = false;
          (this.scene as cScene).triggerSceneEvent("completed_child", { 
            ending:this.yy,
            game: ''+this.curGame,
            display:  this.endMapping[ this.curGame+'_'+this.yy ]
          });
  
        }
      }
    });

    this.scene.tweens.add({
      targets: this,
      camX: (this.xx * 50)-960,
      duration: 1500,
      ease:'Quad.easeInOut'
    });
  }


  buildScene() {
    super.buildScene();
    this.scene.events.on('update', (time, delta)=>{
      this.update();
    }, this);
    this.holder = this.getByName('controls_holder')
    var cHolder  = this.getByName('cloud_holder')

    this.clouds = this.scene.add.container(0,0)
    
    this.clouds.add( new Phaser.GameObjects.Sprite(this.scene,0,500,'packman_cloud_start'))
    const r = [0,1,2,3,4,5].forEach( (n)=>{
      this.clouds.add( new Phaser.GameObjects.Sprite(this.scene,488 + (n*541) ,495,'packman_cloud_mid'))
    })
    this.clouds.add( new Phaser.GameObjects.Sprite(this.scene,(5*541)+488+488-3,500,'packman_cloud_end'))

    // setTimeout(()=>{
    //   this.scene.children.getAll().forEach( (el)=>console.log('XX',el) )
    // },1)

    this.scene.tweens.add({
      targets: this,
      camX: -960,
      duration: 2000,
      ease:'Quad.easeOut',
      onComplete:()=>{
        (this.scene as cScene).triggerSceneEvent("start_child", { 
          game: ''+this.curGame,
        });
      }
    });    

  }

  update(){
    this.scene.cameras.main.scrollX = this.camX;
    this.clouds.x = -(this.camX * 0.2);
    this.holder.x = this.camX
  }
  
  mounted() {    
  }

  public close(cb: Function): void {
    console.log('CLOSED');

    this.tilemap.destroy();
    super.close(cb);
  }

  closed() {
    this.scene.events.off('update');
  }
}



